const MultiInputWrapper = ({ children, error }: { children: JSX.Element; error: boolean }) => (
  <div className={error ? 'border border-solid border-red-600 p-2 rounded' : ''}>{children}</div>
);

export default MultiInputWrapper;
